module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_arrow_bottom_gray-13f7673ad0051f799528e11b42447c54.svg";